<h1 mat-dialog-title>Patient File Export</h1>

<div mat-dialog-content class="export-progress-content">

    <p class="patient-name" *ngIf="data.patientName">{{ data.patientName }}</p>

    <!-- Running -->
    <ng-container *ngIf="isRunning">
        <p class="status-message">{{ message }}</p>
        <mat-progress-bar color="primary" mode="determinate" [value]="displayProgress"></mat-progress-bar>
        <div class="progress-row">
            <span class="sub-message">{{ subMessage }}</span>
            <span class="percentage">{{ displayProgress }}%</span>
        </div>
        <p class="hint">
            A large patient file can take several minutes to package and upload. You can close
            this window — the export keeps running, and you can reopen it from the patient file.
        </p>
    </ng-container>

    <!-- Completed -->
    <ng-container *ngIf="status === 'completed'">
        <div class="result success">
            <mat-icon>check_circle</mat-icon>
            <div>
                <p class="status-message">Your export is ready.</p>
                <p class="sub-message" *ngIf="generatedAtLabel">Generated {{ generatedAtLabel }}</p>
                <p class="sub-message" *ngIf="subMessage">{{ subMessage }}</p>
                <p class="sub-message" *ngIf="fileName">{{ fileName }}</p>
            </div>
        </div>
        <p class="hint">
            The download link is valid for 60 minutes. If this patient's file has changed since
            it was generated, create a new export.
        </p>
    </ng-container>

    <!-- Failed -->
    <ng-container *ngIf="status === 'failed'">
        <div class="result error">
            <mat-icon>error_outline</mat-icon>
            <div>
                <p class="status-message">The export could not be completed.</p>
                <p class="sub-message">{{ errorMessage }}</p>
            </div>
        </div>
    </ng-container>

</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="downloading">Close</button>
    <button mat-button *ngIf="status === 'completed' || status === 'failed'" (click)="regenerate()"
        [disabled]="downloading">
        {{ status === 'failed' ? 'Try again' : 'New export' }}
    </button>
    <button mat-raised-button color="primary" *ngIf="status === 'completed'" (click)="download()"
        [disabled]="downloading">
        <mat-icon>file_download</mat-icon>
        {{ downloading ? 'Preparing...' : 'Download' }}
    </button>
</div>
